// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"bcfdc15e","290":"a9e2ed55","716":"4ac46988"}[chunkId] + ".chunk.js";
};